
const isDev = process.env.NODE_ENV === 'development';
const API_URL = isDev ? '' : (process.env.REACT_APP_API_BASE_URL || '');

function getBasicAuthHeader() {
    // Prefer env, fallback to localStorage
    const user = process.env.REACT_APP_API_USER ||
        (typeof window !== 'undefined' && window.localStorage.getItem('REACT_APP_API_USER'));
    const pass = process.env.REACT_APP_API_PASSWORD ||
        (typeof window !== 'undefined' && window.localStorage.getItem('REACT_APP_API_PASSWORD'));

    if (user && pass) {
        let encoded;
        if (typeof window !== 'undefined' && window.btoa) {
            encoded = window.btoa(`${user}:${pass}`);
        } else if (typeof Buffer !== 'undefined') {
            encoded = Buffer.from(`${user}:${pass}`).toString('base64');
        }
        return `Basic ${encoded}`;
    }
    return undefined;
}

const getHeaders = () => {
    const headers = {
        'Content-Type': 'application/json',
    };

    const auth = getBasicAuthHeader();
    if (auth) {
        headers['Authorization'] = auth;
    }

    return headers;
};

export const getShippingConfig = async () => {
    try {
        const response = await fetch(`${API_URL}/api/delivery`, {
            headers: getHeaders()
        });

        if (response.status === 404) {
            // Default values if endpoint doesn't exist yet/first run
            return { cashPrice: 0, cardPrice: 0, minimumPoints: 0 };
        }

        if (!response.ok) {
            throw new Error('Error fetching delivery config');
        }

        const data = await response.json();

        // Backend returns a list, we take the first one if available
        if (Array.isArray(data) && data.length > 0) {
            return data[0];
        }

        return { cashPrice: 0, cardPrice: 0, minimumPoints: 0 };
    } catch (error) {
        console.error('Error fetching delivery config:', error);
        return { cashPrice: 0, cardPrice: 0, minimumPoints: 0 };
    }
};

export const saveShippingConfig = async (config) => {
    let url = `${API_URL}/api/delivery`;
    let method = 'POST';

    if (config.id) {
        url = `${API_URL}/api/delivery/${config.id}`;
        method = 'PUT';
    }

    const response = await fetch(url, {
        method: method,
        headers: getHeaders(),
        body: JSON.stringify(config)
    });

    if (!response.ok) {
        throw new Error('Error saving delivery config');
    }

    // Backend returns void (or empty body), so we don't parse JSON
    return true;
};
